import client from 'api/apiClient';
import api from 'api/apiClient';
import { notify } from 'components/Common/Toast';
interface BasketEditEventTypes {
    name: string;
    description: string;
    goalAmount: number;
    type: string;
    estimatedContributors: number;
    endDate: string;
    nextPlannedStatusDate: string;
    nextPlannedStatus: string;
}

export const updateBasketDetail = async (id: any, data: BasketEditEventTypes) => {
    const basketUpdateData = { ...data };
    try {
        const responseEidtBasket = await api.put(`/event/${id}`, basketUpdateData);
        return responseEidtBasket;
    } catch (error) {
        console.log('edit basket error', error);
    }
};

export const updateBasketImage = async (file: string, id: string) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        const res: any = await client.post(`/event/setAvatar/${id}`, formData, {
            'Content-Type': 'multipart/form-data',
        });
        if (res?.code === 200) {
            notify('Image updated successfully', 'success');
        }
        return res;
    } catch (error) {
        throw error;
    }
};

export const removeBasketImage = async (id: string) => {
    try {
        const res: any = await client.delete(`/event/removeAvatar/${id}`);
        if (res?.code === 200) {
            notify('Image removed successfully', 'success');
        }
        return res;
    } catch (error) {
        throw error;
    }
};
